import { List, ListItem, Typography } from '@mui/material'
import ApplicationCard from '@norstella/nxp-sso-web/components/ApplicationCard'
import { useBranding } from '../hooks/useBranding'
import styles from '@norstella/nxp-sso-web/views/EmailCheckFailed.module.scss'
import { ReactElement } from 'react'

export const NonBusinessDomain = () => {
  const [forms] = useBranding()
  const headerMeta = forms.nonBusinessDomain
  const contactsData = headerMeta.contacts
  const contactsList: ReactElement[] = (contactsData?.phones ?? [])
    .filter(Boolean)
    .map(phone => <ListItem key={phone} sx={{ display: 'list-item' }}>{phone}</ListItem>)

  if (contactsData?.email) {
    contactsList.push(
      <ListItem key="email" sx={{ display: 'list-item' }}>
        email: <a href={`mailto:${contactsData.email}`}>{contactsData.email}</a>
      </ListItem>,
    )
  }

  if (contactsData?.link) {
    contactsList.push(
      <ListItem key="link" sx={{ display: 'list-item' }}>
        <a href={contactsData.link.url} target="_blank" rel="noopener nofollow noreferrer">{contactsData.link.text}</a>
      </ListItem>,
    )
  }

  return (
    <>
      {
        <ApplicationCard header={headerMeta.header} description={headerMeta.description}>
          <Typography component="p">
            As a supplier of premium news and data, we ask you to sign up using a valid business email address.
          </Typography>

          {contactsList.length > 0 &&
            <section>
          <Typography component="p">
            Please contact our client services team:
          </Typography>
          <List sx={{
            listStyleType: 'disc',
            listStylePosition: 'inside',
            lineHeight: '4px',
            paddingTop: '1px',
          }} className={styles.contacts} >
            {contactsList}
          </List>
            </section>
          }
        </ApplicationCard>
      }
    </>
  )
}
